<script>
export const group = 'Bottom'
</script>

<script setup>
import TwoLineLowerThird from './shared/TwoLineLowerThird.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const now = new Date()
const hour = now.getMinutes() > 50 ? (now.getHours() + 1) % 24 : now.getHours()
const minutes = 15 < now.getMinutes() && now.getMinutes() < 45 ? '30' : '00'
const fallbackText = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} uur`

const line = computed(() => props.item.enrichment.newsBulletin?.news_reader?.name || fallbackText)

const timeline = ref(null)
const timelineOut = ref(null)

onMounted(() => gsapTimeline({ name: 'NewsBulletinSmall' }).add(timeline))

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  await gsapTimeline({ name: 'NewsBulletinSmall - End' }).add(timelineOut.value())
})
</script>

<template>
  <TwoLineLowerThird title="Nieuws" :line="line" @timeline="timeline = $event" @timelineOut="timelineOut = $event" />
</template>
